import React from "react";

const privacy = [
  {
    title: "Information We Collect",
    subpoints: [
      "Personal Data: Name, email, phone number, CV/resume details.",
      "Employer Data: Company name, contact details, job postings.",
      "Usage Data: IP address, browser type, and site activity for analytics.",
    ],
  },
  {
    title: "How We Use Information",
    subpoints: [
      "To connect job seekers with employers.",
      "To improve platform functionality and user experience.",
      "To send updates, newsletters, and job alerts (opt-in basis).",
    ],
  },
  {
    title: "Data Sharing",
    subpoints: [
      "We do not sell personal data.",
      "Information may be shared with employers when candidates apply for jobs.",
      "Data may be disclosed if required by law or to protect SailorsData’s rights.",
    ],
  },
  {
    title: "Cookies & Tracking",
    description: "SailorsData uses cookies to enhance user experience, remember preferences, and analyze site traffic. Users can disable cookies in their browser settings.",
  },
  {
    title: "Data Security",
    description: "We implement reasonable technical and organizational measures to protect user data. However, no system is 100% secure, and users share information at their own risk.",
  },
  {
    title: "User Rights",
    subpoints: [
      "Access, update, or delete your personal information.",
      "Opt out of marketing communications at any time.",
      "Request data portability or restriction of processing (subject to applicable law).",
    ],
  },
  {
    title: "Third-Party Links",
    description: "SailorsData may contain links to external websites. We are not responsible for their privacy practices.",
  },
  {
    title: "Changes to Policy",
    description: "We may update this Privacy Policy from time to time. Users will be notified of significant changes via email or site announcements.",
  },
];

function PrivacyPolicyPage() {

  return (
    <>
      <section id="privacy" className="contact section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Privacy Policy</h2>
        </div>

        <div className="container" data-aos="fade" data-aos-delay="100">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {privacy.map((item, idx) => (
                <div key={idx} className="mb-4">
                  <h5 className="mb-2">{idx + 1}. {item.title}</h5>
                  {item.description && <p className="text-secondary">{item.description}</p>}
                  {item.subpoints && (
                    <ul className="list-unstyled ms-3">
                      {item.subpoints.map((point, i) => (
                        <li key={i} className="mb-1">
                          <i className="bi bi-dot me-2 text-primary"></i>
                          {point}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PrivacyPolicyPage;
